export var GeneralFilterType;
(function (GeneralFilterType) {
    GeneralFilterType["INCLUDE_ALL"] = "INCLUDE_ALL";
    GeneralFilterType["ADVANCED"] = "ADVANCED";
    GeneralFilterType["INVALID"] = "INVALID";
    GeneralFilterType["CONDITION"] = "CONDITION";
    GeneralFilterType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
})(GeneralFilterType = GeneralFilterType || (GeneralFilterType = {}));
export var DateTimeFilterType;
(function (DateTimeFilterType) {
    DateTimeFilterType["PERIOD"] = "PERIOD";
    DateTimeFilterType["DATE_RANGE"] = "DATE_RANGE";
})(DateTimeFilterType = DateTimeFilterType || (DateTimeFilterType = {}));
export var NumericFilterType;
(function (NumericFilterType) {
    NumericFilterType["NUMERIC_RANGE"] = "NUMERIC_RANGE";
})(NumericFilterType = NumericFilterType || (NumericFilterType = {}));
export var DatetimeLevel;
(function (DatetimeLevel) {
    DatetimeLevel["YEARS"] = "years";
    DatetimeLevel["QUARTERS"] = "quarters";
    DatetimeLevel["MONTHS"] = "months";
    DatetimeLevel["WEEKS"] = "weeks";
    DatetimeLevel["DAYS"] = "days";
    DatetimeLevel["HOURS"] = "hours";
    DatetimeLevel["MINUTES"] = "minutes";
})(DatetimeLevel = DatetimeLevel || (DatetimeLevel = {}));
export var FilterModalType;
(function (FilterModalType) {
    FilterModalType["DATE_TIME"] = "datetime";
    FilterModalType["NUMERIC"] = "numeric";
    FilterModalType["TEXT"] = "text";
})(FilterModalType = FilterModalType || (FilterModalType = {}));
export const nonSupportedMinutesBuckets = ['1', '30'];
export const FILTER_TYPES = Object.assign(Object.assign(Object.assign({}, GeneralFilterType), DateTimeFilterType), NumericFilterType);
export const DEFAULT_FILTER_JAQL_BY_TYPE_MAP = {
    [FILTER_TYPES.INCLUDE_ALL]: {
        all: true,
        filterType: FILTER_TYPES.INCLUDE_ALL,
    },
    [FILTER_TYPES.PERIOD]: {
        last: { count: 1, offset: 1 },
        isNotCurrentPeriod: true,
        filterType: FILTER_TYPES.PERIOD,
    },
    [FILTER_TYPES.DATE_RANGE]: {
        filterType: FILTER_TYPES.DATE_RANGE,
    },
    [FILTER_TYPES.NUMERIC_RANGE]: {
        filterType: FILTER_TYPES.NUMERIC_RANGE,
    },
    [FILTER_TYPES.CONDITION]: {
        explicit: false,
        multiSelection: true,
        exclude: { members: [] },
        filterType: FILTER_TYPES.CONDITION,
    },
    [FILTER_TYPES.SPECIFIC_ITEMS]: {
        explicit: true,
        multiSelection: true,
        members: [],
        filterType: FILTER_TYPES.SPECIFIC_ITEMS,
    },
};
export const DEFAULT_FILTER_JAQL_WRAPPER = {
    filter: DEFAULT_FILTER_JAQL_BY_TYPE_MAP.INCLUDE_ALL,
    level: DatetimeLevel.YEARS,
};
export var ConditionFilterType;
(function (ConditionFilterType) {
    ConditionFilterType["IS"] = "members";
    ConditionFilterType["IS_NOT"] = "exclude";
    ConditionFilterType["IS_WITHIN"] = "isWithin";
    ConditionFilterType["TOP"] = "top";
    ConditionFilterType["BOTTOM"] = "bottom";
    ConditionFilterType["AFTER"] = "after";
    ConditionFilterType["BEFORE"] = "before";
    ConditionFilterType["STARTS_WITH"] = "startsWith";
    ConditionFilterType["DOESNT_START_WITH"] = "doesntStartWith";
    ConditionFilterType["ENDS_WITH"] = "endsWith";
    ConditionFilterType["DOESNT_END_WITH"] = "doesntEndWith";
    ConditionFilterType["CONTAINS"] = "contains";
    ConditionFilterType["DOESNT_CONTAIN"] = "doesntContain";
    ConditionFilterType["EQUALS"] = "equals";
    ConditionFilterType["DOESNT_EQUAL"] = "doesntEqual";
    ConditionFilterType["IS_EMPTY"] = "isEmpty";
    ConditionFilterType["IS_NOT_EMPTY"] = "isNotEmpty";
    ConditionFilterType["GREATER_THAN"] = "fromNotEqual";
    ConditionFilterType["GREATER_THAN_OR_EQUAL"] = "from";
    ConditionFilterType["LESS_THAN"] = "toNotEqual";
    ConditionFilterType["LESS_THAN_OR_EQUAL"] = "to";
    ConditionFilterType["BETWEEN"] = "between";
    ConditionFilterType["IS_NOT_BETWEEN"] = "isNotBetween";
    ConditionFilterType["MULTIPLE_CONDITION"] = "multipleCondition";
    ConditionFilterType["NONE"] = "none";
})(ConditionFilterType = ConditionFilterType || (ConditionFilterType = {}));
//# sourceMappingURL=types.js.map